const NS = 'SiteHeaderMicronWidget';
const CLS = 'siteHeaderMicronWidget';

export class SiteHeaderMicronWidget {
	constructor(element) {
		this.element = element;
		this.$element = $(element);

		this.$siteHeaderWidget = this.$element.parents('.siteHeaderWidget');
		this.$buttonClose = this.$element.find(`.${CLS}-btn--close`);

		this.isDataClosed = this.getIsClosed();

		if(!_.isNil(this.isDataClosed) && !this.isDataClosed) {
			this.showWidget(false);
			this.$siteHeaderWidget.trigger('siteHeaderWidget.siteHeaderTopWidget.marketUpdateButton.addClass', {});
		}

		this.$buttonClose.on('click', () => {
			this.$siteHeaderWidget.trigger(`siteHeaderWidget.${CLS}.close`, {});
		});

		this.$element.on(`${CLS}.marketUpdateButton.close`, () => {
			this.hideWidget();
		});

		this.$element.on(`${CLS}.marketUpdateButton.toggle`, () => {
			this.$element.slideToggle();
			if(this.$element.attr('data-closed') === 'true') {
				this.showWidget();
			}
			else {
				this.hideWidget();
			}
		});
	}

	hideWidget() {
		this.$siteHeaderWidget.trigger('siteHeaderWidget.siteHeaderMicronWidget.menuWidgets.close', {});
		this.$element.slideUp({
			complete: () => {
				this.$element.attr('data-closed', true);
				this.setIsClosed(true);
				this.isDataClosed = true;
			}
		});
	}

	showWidget(animate = true) {
		this.$siteHeaderWidget.trigger('siteHeaderWidget.siteHeaderMicronWidget.menuWidgets.close', {});
		let show = () => {
			this.$element.attr('data-closed', false);
			this.setIsClosed(false);
			this.isDataClosed = false;
		};

		if(animate) {
			this.$element.slideDown({
				complete: show()
			});
		}
		else {
			show();
		}
	}

	getIsClosed() {
		let isClosed = parseInt(localStorage.getItem('awi.wool.siteHeaderMicronWidget.closed'));

		if(!_.isNil(isClosed)) {
			let value = (isClosed === 1) ? true : false;
			return value;
		}
		else {
			this.setIsClosed(true);
		}
		return true;
	}

	setIsClosed(oldValue) {
		let newValue = oldValue ? 1: 0;
		localStorage.setItem('awi.wool.siteHeaderMicronWidget.closed', newValue);
	}
}
